<template>
  <v-container class="fill-height">
    <!-- <pre>{{menu}}</pre> -->
    <v-row align="center" justify="center">
      <template v-for="(item, i) in menu">
        <v-col :key="i" cols="12" md="4" sm="4" align="center" v-show="item.permission">
          <v-hover v-slot:default="{ hover }">
            <v-card
              width="500"
              height="500"
              class="card_hover pa-5 py-10 text-center"
              :elevation="hover ? 12 : 2"
              :class="{ 'on-hover': hover }"
              :to="item.path"
            >
              <v-container class="fill-height">
                <v-row justify="center" align="center">
                  <v-col cols="12" justify="center" align="center">
                    <v-avatar tile size="150">
                      <v-img :src="item.img" height="auto" cover></v-img>
                    </v-avatar>
                    <v-card-title class="title mt-10 mb-0 pb-0">
                      <v-divider></v-divider>
                      <v-row class="fill-height flex-column text-center" justify="space-between">
                        <span class="gradient-font text_title_2">{{ item.th_title }}</span>
                      </v-row>
                      <v-divider></v-divider>
                    </v-card-title>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-hover>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      // permmission variable
      permission_languge: false,
      permission_category: false,
      permission_role: false,

      model: null,
      icons: "mdi-chevron-right",
      menu: [
        {
          th_title: "ภาษา",
          title: "Language",
          img: require("@/assets/icon/translation.svg"),
          permission: false,
          permission_name: "language",
          path: "/setting/language",
        },
        {
          th_title: "หมวดหมู่",
          title: "Category",
          img: require("@/assets/icon/category.svg"),
          permission: false,
          permission_name: "category",
          path: "/setting/category",
        },
        {
          th_title: "สิทธิ์การใช้งาน",
          title: "Permission",
          img: require("@/assets/icon/permission.svg"),
          permission: false,
          permission_name: "permission",
          path: "/setting/permission",
        },
      ],
      transparent: "rgba(255, 255, 255, 0)",
    };
  },
  created() {
    const module_name = "permission_setting";
    const func_list = ["language", "category", "permission"];
    const redirect = { name: "Dashboard", params: { mode: "all" } };
    if (this.$session.get(module_name)) {
      if (this.$session.get(module_name).length > 0) {
        this.menu.forEach((item) => {
          func_list.forEach((func) => {
            if (item.permission_name == func) {
              item.permission = this.$session.get(module_name).includes(func);
            }
          });
        });
      } else {
        this.$router.push(redirect);
      }
    } else {
      this.$router.push(redirect);
    }
  },
  methods: {
    initialMethod() {},
  },
};
</script>
<style scoped>
.card_hover {
  transition: opacity 0.2s ease-in-out;
}

.card_hover:not(.on-hover) {
  opacity: 0.8;
}

.show-btns {
  /* color: linear-gradient(to right, #3ea6fa, #2769d7, #0c57d2) !important; */
  color: #0c57d2 !important;
}
</style>
